import CoreuiController from "../lib/coreui-controller"
import Tab from "../coreui/tab"

export default class CoreuiTabController extends CoreuiController {
  static Component = Tab
}
